import { LoadingOverlay } from '@mantine/core';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }: any) => {
    const location = useLocation();
    const { isLogged, isLoading } = useSelector((state: any) => state.auth);
    if (isLoading) {
        return <LoadingOverlay visible zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />;
    }
    if (!isLogged) {
        return <Navigate to="/login" state={{ from: location }} />;
    }
    return children;
};

export default PrivateRoute;
